module.exports = __webpack_public_path__ + "img/img-4mobile.7179eb72.png";